/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../types/definitions/vendor/graphql-schema.d";
import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetBoughtItemsQueryVariables = Types.Exact<{
  page: Types.Scalars["Int"]["input"];
  limit: Types.Scalars["Int"]["input"];
}>;
export type GetBoughtItemsQuery = {
  __typename?: "Query";
  client?: {
    __typename?: "Client";
    id: string;
    purchasesCollection: {
      __typename?: "PurchasesCollection";
      purchasesByPage: {
        __typename?: "PurchasesPageConnection";
        pageCount: number;
        edges: Array<{
          __typename?: "PurchasesPageEdge";
          node: {
            __typename?: "KeptItem";
            id: string;
            sku: string;
            orderId: string;
            returnInProgress: boolean;
            variant: {
              __typename?: "ShopProductVariant";
              id: string;
              sku: string;
              url: string;
              mayHaveOutfits: boolean;
              isGoToItem: boolean;
              isHidden: boolean;
              size: {
                __typename?: "Size";
                name: string;
              };
              color: {
                __typename?: "Color";
                name: string;
                uniqueColorId: string;
                swatch: {
                  __typename?: "ColorSwatch";
                  hex: string;
                  url?: string | null;
                };
              };
              image?: {
                __typename?: "ShopMedia";
                id: string;
                altText: string;
                baseUrl: string;
                mediaPath: string;
              } | null;
            };
            shopProduct?: {
              __typename?: "ShopProduct";
              id: string;
              name: string;
              brand: {
                __typename?: "Brand";
                name: string;
              };
            } | null;
          };
        }>;
      };
    };
  } | null;
};
export type ClientWardrobeDataFragment = {
  __typename?: "Client";
  id: string;
  purchasesCollection: {
    __typename?: "PurchasesCollection";
    purchasesByPage: {
      __typename?: "PurchasesPageConnection";
      pageCount: number;
      edges: Array<{
        __typename?: "PurchasesPageEdge";
        node: {
          __typename?: "KeptItem";
          id: string;
          sku: string;
          orderId: string;
          returnInProgress: boolean;
          variant: {
            __typename?: "ShopProductVariant";
            id: string;
            sku: string;
            url: string;
            mayHaveOutfits: boolean;
            isGoToItem: boolean;
            isHidden: boolean;
            size: {
              __typename?: "Size";
              name: string;
            };
            color: {
              __typename?: "Color";
              name: string;
              uniqueColorId: string;
              swatch: {
                __typename?: "ColorSwatch";
                hex: string;
                url?: string | null;
              };
            };
            image?: {
              __typename?: "ShopMedia";
              id: string;
              altText: string;
              baseUrl: string;
              mediaPath: string;
            } | null;
          };
          shopProduct?: {
            __typename?: "ShopProduct";
            id: string;
            name: string;
            brand: {
              __typename?: "Brand";
              name: string;
            };
          } | null;
        };
      }>;
    };
  };
};
export type BoughtItemsFragment = {
  __typename?: "PurchasesCollection";
  purchasesByPage: {
    __typename?: "PurchasesPageConnection";
    pageCount: number;
    edges: Array<{
      __typename?: "PurchasesPageEdge";
      node: {
        __typename?: "KeptItem";
        id: string;
        sku: string;
        orderId: string;
        returnInProgress: boolean;
        variant: {
          __typename?: "ShopProductVariant";
          id: string;
          sku: string;
          url: string;
          mayHaveOutfits: boolean;
          isGoToItem: boolean;
          isHidden: boolean;
          size: {
            __typename?: "Size";
            name: string;
          };
          color: {
            __typename?: "Color";
            name: string;
            uniqueColorId: string;
            swatch: {
              __typename?: "ColorSwatch";
              hex: string;
              url?: string | null;
            };
          };
          image?: {
            __typename?: "ShopMedia";
            id: string;
            altText: string;
            baseUrl: string;
            mediaPath: string;
          } | null;
        };
        shopProduct?: {
          __typename?: "ShopProduct";
          id: string;
          name: string;
          brand: {
            __typename?: "Brand";
            name: string;
          };
        } | null;
      };
    }>;
  };
};
export type BoughtItemsBoughtItemFragment = {
  __typename?: "KeptItem";
  id: string;
  sku: string;
  orderId: string;
  returnInProgress: boolean;
  variant: {
    __typename?: "ShopProductVariant";
    id: string;
    sku: string;
    url: string;
    mayHaveOutfits: boolean;
    isGoToItem: boolean;
    isHidden: boolean;
    size: {
      __typename?: "Size";
      name: string;
    };
    color: {
      __typename?: "Color";
      name: string;
      uniqueColorId: string;
      swatch: {
        __typename?: "ColorSwatch";
        hex: string;
        url?: string | null;
      };
    };
    image?: {
      __typename?: "ShopMedia";
      id: string;
      altText: string;
      baseUrl: string;
      mediaPath: string;
    } | null;
  };
  shopProduct?: {
    __typename?: "ShopProduct";
    id: string;
    name: string;
    brand: {
      __typename?: "Brand";
      name: string;
    };
  } | null;
};
export type BoughtItemsShopProductFragment = {
  __typename?: "ShopProduct";
  id: string;
  name: string;
  brand: {
    __typename?: "Brand";
    name: string;
  };
};
export type BoughtItemsShopProductVariantFragment = {
  __typename?: "ShopProductVariant";
  id: string;
  sku: string;
  url: string;
  mayHaveOutfits: boolean;
  isGoToItem: boolean;
  isHidden: boolean;
  size: {
    __typename?: "Size";
    name: string;
  };
  color: {
    __typename?: "Color";
    name: string;
    uniqueColorId: string;
    swatch: {
      __typename?: "ColorSwatch";
      hex: string;
      url?: string | null;
    };
  };
  image?: {
    __typename?: "ShopMedia";
    id: string;
    altText: string;
    baseUrl: string;
    mediaPath: string;
  } | null;
};
export type ShopProductVariantIsHiddenFragment = {
  __typename?: "ShopProductVariant";
  isHidden: boolean;
};
export const BoughtItemsShopProductVariantFragmentDoc = {
  kind: "Document",
  definitions: [{
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "BoughtItemsShopProductVariant"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "ShopProductVariant"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "id"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "sku"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "url"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "size"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "name"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "color"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "name"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "swatch"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "hex"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "url"
                }
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "uniqueColorId"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "image"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "altText"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "baseUrl"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "mediaPath"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "mayHaveOutfits"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "isGoToItem"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "isHidden"
        }
      }]
    }
  }]
} as unknown as DocumentNode;
export const BoughtItemsShopProductFragmentDoc = {
  kind: "Document",
  definitions: [{
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "BoughtItemsShopProduct"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "ShopProduct"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "id"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "name"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "brand"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "name"
            }
          }]
        }
      }]
    }
  }]
} as unknown as DocumentNode;
export const BoughtItemsBoughtItemFragmentDoc = {
  kind: "Document",
  definitions: [{
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "BoughtItemsBoughtItem"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "KeptItem"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "id"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "sku"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "orderId"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "returnInProgress"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "variant"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "BoughtItemsShopProductVariant"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "shopProduct"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "BoughtItemsShopProduct"
            }
          }]
        }
      }]
    }
  }, {
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "BoughtItemsShopProductVariant"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "ShopProductVariant"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "id"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "sku"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "url"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "size"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "name"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "color"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "name"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "swatch"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "hex"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "url"
                }
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "uniqueColorId"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "image"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "altText"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "baseUrl"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "mediaPath"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "mayHaveOutfits"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "isGoToItem"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "isHidden"
        }
      }]
    }
  }, {
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "BoughtItemsShopProduct"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "ShopProduct"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "id"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "name"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "brand"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "name"
            }
          }]
        }
      }]
    }
  }]
} as unknown as DocumentNode;
export const BoughtItemsFragmentDoc = {
  kind: "Document",
  definitions: [{
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "BoughtItems"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "PurchasesCollection"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "purchasesByPage"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "page"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "page"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "limit"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "limit"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "pageCount"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "edges"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "node"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "FragmentSpread",
                    name: {
                      kind: "Name",
                      value: "BoughtItemsBoughtItem"
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }, {
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "BoughtItemsShopProductVariant"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "ShopProductVariant"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "id"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "sku"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "url"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "size"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "name"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "color"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "name"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "swatch"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "hex"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "url"
                }
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "uniqueColorId"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "image"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "altText"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "baseUrl"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "mediaPath"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "mayHaveOutfits"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "isGoToItem"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "isHidden"
        }
      }]
    }
  }, {
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "BoughtItemsShopProduct"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "ShopProduct"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "id"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "name"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "brand"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "name"
            }
          }]
        }
      }]
    }
  }, {
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "BoughtItemsBoughtItem"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "KeptItem"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "id"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "sku"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "orderId"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "returnInProgress"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "variant"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "BoughtItemsShopProductVariant"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "shopProduct"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "BoughtItemsShopProduct"
            }
          }]
        }
      }]
    }
  }]
} as unknown as DocumentNode;
export const ClientWardrobeDataFragmentDoc = {
  kind: "Document",
  definitions: [{
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "ClientWardrobeData"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "Client"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "id"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "purchasesCollection"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "BoughtItems"
            }
          }]
        }
      }]
    }
  }, {
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "BoughtItemsShopProductVariant"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "ShopProductVariant"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "id"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "sku"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "url"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "size"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "name"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "color"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "name"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "swatch"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "hex"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "url"
                }
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "uniqueColorId"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "image"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "altText"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "baseUrl"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "mediaPath"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "mayHaveOutfits"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "isGoToItem"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "isHidden"
        }
      }]
    }
  }, {
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "BoughtItemsShopProduct"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "ShopProduct"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "id"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "name"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "brand"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "name"
            }
          }]
        }
      }]
    }
  }, {
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "BoughtItemsBoughtItem"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "KeptItem"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "id"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "sku"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "orderId"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "returnInProgress"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "variant"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "BoughtItemsShopProductVariant"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "shopProduct"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "BoughtItemsShopProduct"
            }
          }]
        }
      }]
    }
  }, {
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "BoughtItems"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "PurchasesCollection"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "purchasesByPage"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "page"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "page"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "limit"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "limit"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "pageCount"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "edges"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "node"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "FragmentSpread",
                    name: {
                      kind: "Name",
                      value: "BoughtItemsBoughtItem"
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }]
} as unknown as DocumentNode;
export const ShopProductVariantIsHiddenFragmentDoc = {
  kind: "Document",
  definitions: [{
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "ShopProductVariantIsHidden"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "ShopProductVariant"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "isHidden"
        }
      }]
    }
  }]
} as unknown as DocumentNode;
export const GetBoughtItemsDocument = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "getBoughtItems"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "page"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "Int"
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "limit"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "Int"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "client"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "ClientWardrobeData"
            }
          }]
        }
      }]
    }
  }, {
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "BoughtItemsShopProductVariant"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "ShopProductVariant"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "id"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "sku"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "url"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "size"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "name"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "color"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "name"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "swatch"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "hex"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "url"
                }
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "uniqueColorId"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "image"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "altText"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "baseUrl"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "mediaPath"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "mayHaveOutfits"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "isGoToItem"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "isHidden"
        }
      }]
    }
  }, {
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "BoughtItemsShopProduct"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "ShopProduct"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "id"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "name"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "brand"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "name"
            }
          }]
        }
      }]
    }
  }, {
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "BoughtItemsBoughtItem"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "KeptItem"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "id"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "sku"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "orderId"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "returnInProgress"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "variant"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "BoughtItemsShopProductVariant"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "shopProduct"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "BoughtItemsShopProduct"
            }
          }]
        }
      }]
    }
  }, {
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "BoughtItems"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "PurchasesCollection"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "purchasesByPage"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "page"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "page"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "limit"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "limit"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "pageCount"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "edges"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "node"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "FragmentSpread",
                    name: {
                      kind: "Name",
                      value: "BoughtItemsBoughtItem"
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }, {
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "ClientWardrobeData"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "Client"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "id"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "purchasesCollection"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "BoughtItems"
            }
          }]
        }
      }]
    }
  }]
} as unknown as DocumentNode;

/**
 * __useGetBoughtItemsQuery__
 *
 * To run a query within a React component, call `useGetBoughtItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBoughtItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBoughtItemsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetBoughtItemsQuery(baseOptions: Apollo.QueryHookOptions<GetBoughtItemsQuery, GetBoughtItemsQueryVariables> & ({
  variables: GetBoughtItemsQueryVariables;
  skip?: boolean;
} | {
  skip: boolean;
})) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useQuery<GetBoughtItemsQuery, GetBoughtItemsQueryVariables>(GetBoughtItemsDocument, options);
}
export function useGetBoughtItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBoughtItemsQuery, GetBoughtItemsQueryVariables>) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useLazyQuery<GetBoughtItemsQuery, GetBoughtItemsQueryVariables>(GetBoughtItemsDocument, options);
}
// @ts-ignore
export function useGetBoughtItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBoughtItemsQuery, GetBoughtItemsQueryVariables>): Apollo.UseSuspenseQueryResult<GetBoughtItemsQuery, GetBoughtItemsQueryVariables>;
export function useGetBoughtItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBoughtItemsQuery, GetBoughtItemsQueryVariables>): Apollo.UseSuspenseQueryResult<GetBoughtItemsQuery | undefined, GetBoughtItemsQueryVariables>;
export function useGetBoughtItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBoughtItemsQuery, GetBoughtItemsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useSuspenseQuery<GetBoughtItemsQuery, GetBoughtItemsQueryVariables>(GetBoughtItemsDocument, options);
}
export type GetBoughtItemsQueryHookResult = ReturnType<typeof useGetBoughtItemsQuery>;
export type GetBoughtItemsLazyQueryHookResult = ReturnType<typeof useGetBoughtItemsLazyQuery>;
export type GetBoughtItemsSuspenseQueryHookResult = ReturnType<typeof useGetBoughtItemsSuspenseQuery>;
export type GetBoughtItemsQueryResult = Apollo.QueryResult<GetBoughtItemsQuery, GetBoughtItemsQueryVariables>;